// services/api.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dashboard-api.alizee-soft.com';

export const api = axios.create({ 
  baseURL: API_BASE_URL,
});



api.interceptors.request.use(config => {
  const loginCode = localStorage.getItem('loginCode');
  const clientCode = localStorage.getItem('clientCode');
  const userId = localStorage.getItem('userId');

    // 🔴 N’ajoute rien si on appelle /me avec X-EMAIL/X-PASSWORD
  if (config.url?.includes('/me') && config.headers['X-EMAIL']) {
    return config;
  }

  if (loginCode) {
    config.headers['X-LOGIN-CODE'] = loginCode;
  }

  // if (clientCode) {
  //   // Injecter le clientCode dans l'URL automatiquement
  //   const url = new URL(config.url ?? '', 'http://dummy'); // pour manipuler l'URL proprement
  //   if (!url.searchParams.has('clientCode')) {
  //     url.searchParams.append('clientCode', clientCode);
  //   }

  //   config.url = url.pathname + url.search;
  // }

   // Ajoute ?clientCode=... sans casser l'hôte
  if (clientCode) {
    config.params = {
      ...(config.params || {}),
      ...(clientCode ? { clientCode } : {}),
      ...(userId ? { userId } : {}),
    };
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const url = err.config?.url || '';

    // Déconnexion automatique seulement si ce n’est PAS la route /me
    if (status === 401 && !url.includes('/me')) {
      localStorage.removeItem('loginCode');
      localStorage.removeItem('clientCode');
      localStorage.removeItem('userId');
      window.location.href = '/';
    }

    return Promise.reject(err);
  }
);


